// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3rmSkonCSraS1IAo9PjVXN","checkbox":"_1ryt6DS58T2bnl5c9-8C0T","large":"_31p90ZkHGxZYt3enju6Kbm","inner":"AR72x5PXxuQNTCR482G1x","indeterminate":"_38RenuI68x8VfOp5PMc3MF","children":"gy5ciNJqeAd24GlZp9uUj","checked":"_1NsmkjAWMYZcapL5kKS3Xm","unchecked":"ijee37Pp_R2QbyrXMBhd0","hover":"_3VhucWJ6AMYv-30HM9piAp","active":"_1RvCZ7wH07DCLAC-h-N9Wa","disabled":"_1bDvqpnUFoCOZRS2w9Myxj","hasError":"Xz4lTH1pVWdGekXSh2mEV"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Checkbox/Checkbox.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Checkbox/Checkbox.scss
// module chunks = 0